import { render } from "./loaderIn.vue?vue&type=template&id=b2764386&scoped=true&lang=html"
import script from "./loaderIn.vue?vue&type=script&lang=js"
export * from "./loaderIn.vue?vue&type=script&lang=js"

import "./loaderIn.vue?vue&type=style&index=0&id=b2764386&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2764386"]])

export default __exports__